const HTML_TAG_REGEX = /<[^>]*>/g;
const HTML_SPACE_ENTITY_REGEX = /&nbsp;/g;

// NOTE: DES 는 값 없음을 하이픈으로 표기하는 관례가 있어(EMPTY_SHELL_VALUE) 빈 값으로 함께 취급한다.
const EMPTY_PLACEHOLDER = "-";

/**
 * 편집 가능한 텍스트(HTML 문자열)에 실제 내용이 없는지 판단한다.
 * 태그·공백 엔티티를 걷어낸 뒤 남는 게 없거나 하이픈뿐이면 빈 값으로 본다.
 */
export const isEmptyEditableText = (text?: string) => {
  if (!text) return true;

  const plainText = text
    .replace(HTML_TAG_REGEX, " ")
    .replace(HTML_SPACE_ENTITY_REGEX, " ")
    .trim();

  return plainText === "" || plainText === EMPTY_PLACEHOLDER;
};
